import { useValidate } from "formvalidation/hooks";
import React from "react";
import { useCustomQuery, useSemanticUiInputRef } from "utilities/hookutils";
import PasswordInputBase from "./PasswordInputBase";

interface FirstPasswordInputProps {
  validatorKey: string
  value: string
  onChange: (value: string) => void
}

const CurrentPasswordInput = ({ validatorKey, value, onChange }: FirstPasswordInputProps) => {
  const inputRef = useSemanticUiInputRef();

  const passwordValidator = useCustomQuery({
    queryKey: ["passwordValidator", value],
    queryFn: () => window.CoreApi.Account.ValidateMyPassword({ password: value }).then(r => r.data),
    staleTime: 1000 * 60 * 60, // cache result for 1 hour
    enabled: false,
  });

  const validateCurrentPassword = async (): Promise<string | boolean> => {
    if (value.trim() === "") {
      return RESX.GeneralWarnings.PleaseFillInThisField;
    }

    const isCorrectResult = await passwordValidator.refetch();

    if (isCorrectResult.data.hasErrors) {
      return RESX.SoUser.TheProvidedPasswordIsIncorrect;
    }

    return true;
  };

  const validator = useValidate({
    key: validatorKey,
    title: RESX.PersonalSettings.CurrentPassword,
    value,
    validate: validateCurrentPassword,
    ref: inputRef.ref,
    type: "manual"
  })

  return (
    <PasswordInputBase
      value={value}
      error={validator.error.errorMessage ?? validator.error.hasError}
      onChange={onChange}
      innerRef={inputRef}
      isLoading={passwordValidator.isFetching}
      onBlur={validator.validateAndSetError}
    />
  );
};

export default CurrentPasswordInput;
